import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/operations`;

// Send the untouched File bytes. Canvas resizing strips EXIF GPS, timestamps and
// orientation, so it must never happen before the original is persisted.
// Backend generates a separate small JPEG thumbnail after saving the original.
const UPLOAD_CONCURRENCY = 4;
export const PHOTO_ACCEPT = "image/*";

async function uploadOne(projectId, file, onProgress) {
  const form = new FormData();
  form.append("file", file, file.name);
  const res = await axios.post(`${API}/projects/${projectId}/photos`, form, {
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) return;
      onProgress(Math.min(1, event.loaded / event.total));
    },
  });
  return res.data;
}

async function withConcurrency(items, limit, worker) {
  const results = new Array(items.length);
  const failures = [];
  let cursor = 0;
  const pump = async () => {
    while (true) {
      const index = cursor++;
      if (index >= items.length) return;
      try {
        results[index] = await worker(items[index], index);
      } catch (error) {
        failures.push(error);
      }
    }
  };
  await Promise.all(
    Array.from({ length: Math.min(limit, items.length) }, () => pump()),
  );
  if (failures.length) {
    const error = new Error("Some photo uploads could not be confirmed");
    error.uploadedCount = items.length - failures.length;
    error.failedCount = failures.length;
    throw error;
  }
  return results;
}

/** Upload untouched original files, retaining embedded EXIF GPS.
 * Files exceeding the backend's upload-size limit are rejected explicitly:
 * never downscale or replace an original without the user's permission.
 */
export async function uploadPhotosToProject(projectId, files, onProgress) {
  return withConcurrency(Array.from(files), UPLOAD_CONCURRENCY, (file, index) =>
    uploadOne(projectId, file, (progress) => onProgress?.(index, progress)),
  );
}
